module.exports = __webpack_public_path__ + "static/profilepic-c1ccf81395f03b7f40230644ddb5e0ac.jpg";